import RetailersList from "./RetailersList";

export default RetailersList;
